import z from "zod";

/**
 * CadastroAprovadorSchema
 */

export const CadastroAprovadorSchema = z.object({
  idFuncionario: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }).positive(),
  email: z.string().nonempty('Este campo deve ser preenchido!'),
  valorMaximo: z.coerce.number().nullable().default(null),
});

/**
 * CadastroAprovadorForm
 */

export type CadastroAprovadorForm = z.infer<typeof CadastroAprovadorSchema>;

/**
 * defaultCadastroAprovadorForm
 */

export const defaultCadastroAprovadorForm: CadastroAprovadorForm = {
  idFuncionario: 0,
  email: '',
  valorMaximo: null,
};